import React, { useContext, useEffect, useState } from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';

import { ApiContext } from '@api/api';
import { ShipmentStateCodeEnum } from '@api/ringil-api.v2';
import { useSearchParams } from 'react-router-dom';
import CreateSupplierNotification, { SupplierNotificationForm } from '@app/pages/customer/supplier-notification/CreateSupplierNotification.tsx';
import { shipmentDataToFrameworkOrder } from '@app/pages/customer/supplier-notification/snFrameworkOrders';
import { docNumbersFromShipmentId } from '@app/pages/customer/supplier-notification/utils.ts';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CreateSupplierNotificationPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  const [searchParams] = useSearchParams();

  const fromShipmentId = searchParams.get('fromShipmentId');

  const { getShipmentDataForSupplierNotification } = useContext(ApiContext);

  const [initialData, setInitialData] = useState<SupplierNotificationForm>();

  useEffect(() => {
    getShipmentDataForSupplierNotification(fromShipmentId, data => {
      // The shipment keeps a single document number in shipmentId; spread it into the typed CMR/BL/AWB field for its transport type.
      const docNumbers = docNumbersFromShipmentId(data.transportationType, data.shipmentId);

      setInitialData({
        transportationType: data.transportationType,
        attachments: data.attachmentsData,
        cargoType: { cargoTypeCode: data.cargoType.cargoType.cargoTypeCode, adrWeight: data.cargoType.adrWeight },
        containerInfo: data.containerInfo,
        customsTypeCode: data.customsTypeCode,
        referralCode: data.referralCode,
        fromShipmentId,
        orders: data.orders.map(shipmentDataToFrameworkOrder),
        companyId: null,
        supplierId: null,
        specialRequirementIds: data.specialRequirementIds,
        supplierLocationId: null,
        customerLocationId: null,
        shipmentStateCode: ShipmentStateCodeEnum.WAITING,
        notifyData: { notifyUsersDependsOnRole: true },
        shipmentId: data.shipmentId,
        cmrNumber: docNumbers.cmrNumber,
        blNumber: docNumbers.blNumber,
        awbNumber: docNumbers.awbNumber,
        supplierDeliverySlots: { dayWithInterval: [], timezoneId: null },
        customerDeliverySlots: { dayWithInterval: [], timezoneId: null },
        counterPartyNotifyPersonsIds: [],
        labels: [],
      });
    });
  }, [fromShipmentId]);

  return (
    <>
      <ResponsiveLayout title={tr(`create-shipment.createSupplierNotification`, `Create aviso`)}>{initialData &&
        <CreateSupplierNotification initialData={initialData} />}</ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(CreateSupplierNotificationPage);